import { useEffect, useState } from "react";
import {
  TemperatureRange,
  TemperatureSelectType,
} from "../../context/formContext/types";
import RangeSelectItem from "./RangeSelectItem";
import { TemperatureSelectProps } from "./interfaces/TemperatureSelectProps";

const FixedRangeSelect: React.FC<FixedRangeSelectProps> = ({
  ranges,
  temperatureValue,
  setTemperatureValue,
}) => {
  const [selectedRangeIndex, setSelectedRangeIndex] = useState<number | null>(
    null
  );

  useEffect(() => {
    if (selectedRangeIndex !== null) {
      setTemperatureValue({
        type: TemperatureSelectType.RANGE,
        temperature: { ...ranges[selectedRangeIndex] },
      });
    }
  }, [selectedRangeIndex]);

  useEffect(() => {
    if (temperatureValue === null) {
      setSelectedRangeIndex(null);
    }
  }, [temperatureValue]);

  return (
    <div className="fixed-range-select">
      {ranges.map((range, index) => (
        <RangeSelectItem
          key={index}
          min={range.temperature[0]}
          max={range.temperature[1]}
          isRecommended={range.isRecommended}
          onSelect={() => {
            setSelectedRangeIndex(index);
          }}
          isSelected={index === selectedRangeIndex}
        ></RangeSelectItem>
      ))}
    </div>
  );
};

export default FixedRangeSelect;

export interface FixedRangeSelectProps extends TemperatureSelectProps {
  ranges: TemperatureRange[];
}
